'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useSearchBox } from 'react-instantsearch';
import avo from 'analytics/avo';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import getQuickLinkMatch from './getQuickLinkMatch';

/**
 * When the typed query exactly matches (case insensitive) one of the keywords
 * configured in SEARCH_QUICK_LINKS, renders a "Go to X page" dialog INSTEAD
 * of its children (the search results dropdown), so the results panel never
 * opens for those queries. With no match, renders children untouched.
 */
const QuickLinkDialog = t0 => {
  const $ = _c(10);
  const {
    toggleSearchOpen,
    children
  } = t0;
  const {
    query
  } = useSearchBox();
  const currentPage = useUserCurrentPageType();
  let t1;
  if ($[0] !== query) {
    t1 = getQuickLinkMatch(query);
    $[0] = query;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const match = t1;
  let t2;
  if ($[2] !== currentPage || $[3] !== query || $[4] !== toggleSearchOpen) {
    t2 = () => {
      avo.productsSearched({
        query,
        location: currentPage,
        searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
      });
      toggleSearchOpen?.();
    };
    $[2] = currentPage;
    $[3] = query;
    $[4] = toggleSearchOpen;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleClick = t2;
  if (!match) {
    return children || null;
  }
  let t3;
  if ($[6] !== handleClick || $[7] !== match.pageName || $[8] !== match.url) {
    t3 = <div className="bg-white absolute w-full" data-xc="search-quick-link-dialog"><div className="flex items-center justify-center px-6 py-10"><Link className="bg-gray text-white text-sm font-bold px-6 py-3 no-underline hover:bg-gray-800 transition-colors" to={match.url} onClick={handleClick} data-xc="search-quick-link-dialog-cta">Go to the {match.pageName} page</Link></div></div>;
    $[6] = handleClick;
    $[7] = match.pageName;
    $[8] = match.url;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
QuickLinkDialog.propTypes = {
  toggleSearchOpen: PropTypes.func,
  children: PropTypes.node
};
export default QuickLinkDialog;